import Vue from 'vue';
import Modal from '@/components/common/Modal.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import { Mutations, ResponseStatusCodes } from '@/util/settings/enums';
import { computed } from '@vue/composition-api';
export default Vue.extend({
    components: {
        Modal,
        CommonButton
    },
    props: {
        header: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false
        },
        enableCloseButton: {
            type: Boolean,
            required: false,
            default: false
        },
        closeButtonLabel: {
            type: String,
            required: false
        },
        closeButtonAriaLabel: {
            type: String,
            required: false
        },
        badRequestContent: {
            type: String,
            required: false,
            default: 'Bad request'
        },
        unauthorizedContent: {
            type: String,
            required: false,
            default: 'Unauthorized'
        },
        conflictContent: {
            type: String,
            required: false,
            default: 'Conflict'
        },
        internalServerErrorContent: {
            type: String,
            required: false,
            default: 'Internal server error'
        },
        notFoundContent: {
            type: String,
            required: false,
            default: 'Not found'
        }
    },
    setup(props, { root }) {
        function getErrorContent() {
            switch (root.$store.state.Settings.apiErrorCode) {
                case ResponseStatusCodes.BAD_REQUEST:
                    return props.badRequestContent;
                case ResponseStatusCodes.UNAUTHORIZED:
                    return props.unauthorizedContent;
                case ResponseStatusCodes.NOT_FOUND:
                    return props.notFoundContent;
                case ResponseStatusCodes.CONFLICT:
                    return props.conflictContent;
                case ResponseStatusCodes.INTERNAL_SERVER_ERROR:
                    return props.internalServerErrorContent;
                default:
                    return 'Internal server error';
            }
        }
        function closeModal() {
            const error = {
                isError: false,
                statusCode: null
            };
            root.$store.commit(Mutations.SET_FORM_API_ERROR, error);
        }
        const modalContent = computed(() => getErrorContent());
        return {
            closeModal, modalContent
        };
    }
});
